import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getAriaAttributes } from '../../../../../util/getAriaAttributes/getAriaAttributes.js';
import { getDataAttributes } from '../../../../../util/getDataAttributes/getDataAttributes.js';
import { extractMargins } from '../../../../../util/spacing.js';
import { useExperimentContext } from '../../../../../contexts/session/Experiment.js';

var _excluded = ["id", "size", "color", "direction", "skeleton", "shape", "label", "opacity"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useIconV2ToV3Adapter = function useIconV2ToV3Adapter(props) {
  var experiments = useExperimentContext();
  if (experiments.iconsMigrationToV3) {
    var _v2Props$label;
    var id = props.id,
      size = props.size,
      color = props.color,
      direction = props.direction,
      skeleton = props.skeleton,
      shape = props.shape,
      label = props.label,
      opacity = props.opacity,
      rest = _objectWithoutProperties(props, _excluded);
    var _extractMargins = extractMargins(rest),
      margins = _extractMargins.margins,
      marginsRest = _extractMargins.rest;
    var _getDataAttributes = getDataAttributes(marginsRest),
      dataAttributes = _getDataAttributes.dataAttributes,
      dataRest = _getDataAttributes.rest;
    var _getAriaAttributes = getAriaAttributes(dataRest),
      ariaAttributes = _getAriaAttributes.ariaAttributes;
    var v2Props = {
      id: id,
      color: color,
      skeleton: skeleton,
      size: size,
      label: label,
      direction: direction,
      // we do not use this property in IconV3 but have it here to show that this property is handled
      shape: shape,
      // we do not use this property in IconV3 but have it here to show that this property is handled
      opacity: opacity // we do not use this property in IconV3 but have it here to show that this property is handled
    };
    return {
      iconV3Props: _objectSpread(_objectSpread({
        iconId: v2Props.id,
        color: v2Props.color === undefined ? 'inherit' : v2Props.color,
        showLoading: v2Props.skeleton,
        staticSize: v2Props.size,
        // Although we did not include aria-label as part of our props and even provided a separate `label`
        // property to automatically set the needed accessibility attributes, some consumers still used
        // aria-label and aria-hidden. That worked, because the old icon component spreads all rest props.
        // During the migration, we try to make the component as accessible as we can, so we handle that
        // "incorrect usage" scenario too
        'aria-label': (_v2Props$label = v2Props.label) !== null && _v2Props$label !== void 0 ? _v2Props$label : ariaAttributes['aria-label']
      }, margins), dataAttributes)
    };
  }
  return {
    iconV2Props: props
  };
};

export { useIconV2ToV3Adapter };
//# sourceMappingURL=useIconV2ToV3Adapter.js.map
